export const TrashBasketIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
  >
    <path
      d="M2.80179 17.0195C2.32321 17.0195 1.915 16.8509 1.57714 16.5138C1.24 16.1766 1.07143 15.7684 1.07143 15.2891V2.01948H0V0.948047H4.28571V0.123047H10.7143V0.948047H15V2.01948H13.9286V15.2891C13.9286 15.782 13.7636 16.1934 13.4336 16.5234C13.1029 16.8541 12.6911 17.0195 12.1982 17.0195H2.80179ZM12.8571 2.01948H2.14286V15.2891C2.14286 15.4813 2.20464 15.6391 2.32821 15.7627C2.45179 15.8863 2.60964 15.948 2.80179 15.948H12.1982C12.3625 15.948 12.5136 15.8795 12.6514 15.7423C12.7886 15.6045 12.8571 15.4534 12.8571 15.2891V2.01948ZM5.15143 13.8052H6.22286V4.16233H5.15143V13.8052ZM8.77714 13.8052H9.84857V4.16233H8.77714V13.8052Z"
      fill="black"
    />
  </svg>
);
